import ShippingConstant from '../../constant/order/ShippingConstant';

export default {
    /**
     *
     * @param order
     * @param itemsToShip
     * @param note
     * @param tracks
     * @return {{note: *, type: string, itemsToShip, tracks: *, order: *}}
     */
    createShipment(order, itemsToShip = {}, note = null, tracks = null) {
        return {
            type: ShippingConstant.ORDER_CREATE_SHIPMENT,
            order,
            itemsToShip,
            note,
            tracks
        }
    },

    /**
     *
     * @param order
     * @return {{type: string, order: *}}
     */
    createShipmentAfter(order) {
        return {
            type: ShippingConstant.ORDER_CREATE_SHIPMENT_AFTER,
            order
        }
    },

    /**
     *
     * @param order
     * @return {{type: string, order: *}}
     */
    startLoadProductQtys(order, associatedCustomer) {
        console.log("🛠 startLoadProductQtys chamado!");
        console.log("📦 Pedido (order):", order);
        console.log("👤 Cliente associado (associatedCustomer Shippingaction):", associatedCustomer);
    
        return {
            type: ShippingConstant.ORDER_CREATE_SHIPMENT_LOAD_PRODUCT_QTYS_BEGIN,
            order,
            associatedCustomer,
        }
    },
    

    /**
     *
     * @param productQtys
     * @return {{productQtys: *, type: string}}
     */
    finishLoadProductQtys(productQtys, associatedCustomer) {
        return {
            type: ShippingConstant.ORDER_CREATE_SHIPMENT_LOAD_PRODUCT_QTYS_AFTER,
            productQtys,
            associatedCustomer // ✅ Agora incluímos o associatedCustomer
        }
    },
    

    /**
     *
     * @param isCreatingShipment
     * @return {{isCreatingShipment: *, type: string}}
     */
    setIsCreatingShipment(isCreatingShipment) {
        return {
            type: ShippingConstant.ORDER_SET_IS_CREATING_SHIPMENT,
            isCreatingShipment,
        }
    },

    /**
     *
     * @param isCreateShipment
     * @return {{isCreateShipment: *, type: string}}
     */
    setCheckoutIsCreateShipment(isCreateShipment) {
        return {
            type: ShippingConstant.CHECKOUT_SET_IS_CREATE_SHIPMENT,
            isCreateShipment,
        }
    },
}


// WEBPACK FOOTER //
// ./src/extension/take-shipment/view/action/order/ShippingAction.js